<template>
  <b-card class="card-form" :class="{'ml-0':unshaded,'mr-0':unshaded}">

    <b-card-header class="header-form">

      <b-icon-folder v-if="iconFolder"></b-icon-folder>
      <b-icon-box v-if="iconBox"></b-icon-box>
      <b-icon-card-heading v-if="iconCardHeading"></b-icon-card-heading>
      <b-icon-truck v-if="iconTruck"></b-icon-truck>
      <b-icon-building v-if="iconBuilding"></b-icon-building>
      <b-icon-cash-stack v-if="iconCashStack"></b-icon-cash-stack>
      <b-icon-info-square v-if="iconInfoSquare"></b-icon-info-square>
      <b-icon-chat-right-text v-if="iconChatRightText"></b-icon-chat-right-text>

      <slot name="icon"></slot>
      {{ title }}
      <t-help class="ml-2" :title="help" v-if="help.length > 0"/>

    </b-card-header>


    <!--ATENÇÃO SOMENTE UTILIZAR O SLOT PADRÃO, POIS CASO CONTRÁRIO COM MAIS SLOTS DARÁ PAU NO VALIDADOR-->
    <b-card-body>
      <slot/>
    </b-card-body>

  </b-card>

</template>
<style>
</style>
<script>
export default {
  name: 't-form-card',
  data() {
    return {
      hasSlotHeader: false,
    }
  },
  props: {
    iconFolder: Boolean,
    iconBox: Boolean,
    iconChatRightText: Boolean,
    iconCardHeading: Boolean,
    iconTruck: Boolean,
    iconInfoSquare: Boolean,
    iconBuilding: Boolean,
    iconCashStack: Boolean,
    unshaded: Boolean, //Card solto e não aninhado com outros cards
    title: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },

  },
  mounted() {
    //Validação de slote deve ser feito neste padrão
    this.hasSlotHeader = !!this.$slots.header
  },
  methods: {},

}
</script>
